// extracted by mini-css-extract-plugin
module.exports = {"CertificatesList":"styles_CertificatesList__wbiYV"};